import moment from "moment-timezone";
import Link from "next/link";
import { Play } from "lucide-react";
import Image from "next/image";

export default function CategoryNewsCard({
  image,
  title,
  desc,
  imageAlt,
  time,
  href = "#",
  isVideo,
}) {
  return (
    <Link href={href} className="block border-b pb-4">
      {/* ================= MOBILE VIEW ================= */}
      <div className="block md:hidden">
        {/* IMAGE + OVERLAY */}
        <div className="relative w-full">
          <Image
            src={image}
            alt={imageAlt}
            width={469}
            height={265}
            sizes="(max-width:768px) 100vw, 236px"
            className="rounded"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />

          {isVideo && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-[60px] h-[60px] bg-black/60 rounded-full flex items-center justify-center">
                <Play className="w-8 h-8 text-white fill-white stroke-none" />
              </div>
            </div>
          )}
        </div>

        {/* CONTENT */}
        <div className="flex flex-col justify-end lg:p-4 pt-4">
          <h2 className="font-semibold text-[20px] leading-[22px] mb-1">
            {title}
          </h2>

          <p className="text-gray-600 text-sm mb-2 text-[15px] leading-[23px] line-clamp-4">
            {desc}
          </p>

          <div className="text-black text-[11px]">
            <span>Updated: </span>
            <time dateTime={time}>
              {moment(time).tz("Asia/Kolkata").format("MMM D, YYYY h:mm A")}
            </time>
          </div>
        </div>
      </div>

      {/* ================= DESKTOP VIEW ================= */}
      <div className="hidden md:flex gap-4 items-start">
        <div className="relative flex-shrink-0">
          <Image
            src={image}
            width={216}
            height={144}
            sizes="(max-width:768px) 100vw, 236px"
            alt={imageAlt}
            className="object-cover rounded"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />

          {isVideo && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-[50px] h-[50px] bg-black/60 rounded-full flex items-center justify-center">
                <Play className="w-8 h-8 text-white fill-white stroke-none" />
              </div>
            </div>
          )}
        </div>

        {/* CONTENT */}
        <div className="flex-1">
          <h2 className="font-semibold text-[20px] leading-[22px] mb-1">
            {title}
          </h2>

          <p className="text-gray-600 text-sm mb-2 text-[15px] leading-[23px] line-clamp-4">
            {desc}
          </p>

          <div className="text-black text-[11px]">
            <span>Updated: </span>
            <time dateTime={time}>
              {moment(time).tz("Asia/Kolkata").format("MMM D, YYYY h:mm A")}
            </time>
          </div>
        </div>
      </div>
    </Link>
  );
}
